import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.kommunikation-constants';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationKommunikationConstantsEffects {

    KommunikationConstants$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_KOMMUNIKATION_CONSTANTS),
        mergeMap((x: ac.GetKommunikationConstantsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getKommunikationConstants().pipe(
                map((result: any) => {
                    return new ac.GetKommunikationConstantsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetKommunikationConstantsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.KommunikationTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.KommunikationTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.KommunikationTemplatesService);
        }
        return this.service;
    }
}
